import clsx from 'clsx'
import React from 'react'

const Chips = (props) => {
    
  return (
    <span id={"badge-dismiss-default"} className={clsx("inline-flex gap-4 items-center px-2 py-1 font-medium text-base leading-4 bg-[#F3F4F6] rounded-[8px]", props.chipStyle)}>
        <span className='whitespace-nowrap '>{props.text && props.text}</span>
       {props.icon && <button type="button" onClick={props.handleClick} className="inline-flex items-center p-1 text-base pt-2 text-[#374151] bg-transparent rounded-sm" data-dismiss-target="#badge-dismiss-default" aria-label="Remove">
        {
            props.icon && props.icon
        }
        <span className="sr-only">Remove badge</span>
        </button>}
    </span>
  )
}

export default Chips